import React from "react";
import CrudPage from "@/components/CrudPage";
import { Badge } from "@/components/Common";
import { fmtDate, fmtEuro } from "@/lib/constants";

export default function Finanziamenti() {
  return (
    <CrudPage
      title="Finanziamenti"
      subtitle="Fondi, pratiche, piani formativi e scadenze"
      endpoint="finanziamenti"
      testid="finanziamenti-page"
      allegati
      columns={[
        { key: "fondo", label: "Fondo", render: (r) => <Badge label={r.fondo} cls="bg-emerald-50 text-emerald-700 border-emerald-200" /> },
        { key: "canale", label: "Canale" },
        { key: "titolo_piano", label: "Titolo Piano", render: (r) => <span className="font-medium text-slate-900">{r.titolo_piano}</span> },
        { key: "cup", label: "CUP", render: (r) => <span className="font-mono text-xs">{r.cup || "—"}</span> },
        { key: "finanziamento_approvato", label: "Approvato", render: (r) => fmtEuro(r.finanziamento_approvato) },
        { key: "scadenza_rendiconto", label: "Scad. Rendiconto", render: (r) => fmtDate(r.scadenza_rendiconto) },
      ]}
      fields={[
        { name: "fondo", label: "Fondo", type: "select",
          options: ["FSE+", "GOL", "Formazienda", "Fondimpresa", "Fondirigenti", "Fondartigianato", "Altro"] },
        { name: "canale", label: "Canale", type: "select",
          options: ["CFI", "Avviso", "Contributo aggiuntivo", "Programma Specifico", "Altro"] },
        { name: "titolo_piano", label: "Titolo Piano Formativo", type: "text", full: true },
        { name: "cup", label: "CUP", type: "text" },
        { name: "finanziamento_approvato", label: "Finanziamento approvato (€)", type: "number" },
        { name: "finanziamento_rendicontato", label: "Rendicontato (€)", type: "number" },
        { name: "scadenza_monitoraggio", label: "Scadenza monitoraggio", type: "date" },
        { name: "scadenza_rendiconto", label: "Scadenza rendiconto", type: "date" },
        { name: "stato", label: "Stato", type: "select", options: ["attivo", "chiuso", "sospeso"] },
        { name: "note", label: "Note", type: "textarea", full: true },
      ]}
    />
  );
}
